import { render, staticRenderFns } from "./footerOne.vue?vue&type=template&id=3fe87c80&scoped=true"
import script from "./footerOne.vue?vue&type=script&lang=js"
export * from "./footerOne.vue?vue&type=script&lang=js"
import style0 from "./footerOne.vue?vue&type=style&index=0&id=3fe87c80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fe87c80",
  null
  
)

export default component.exports